import { render, staticRenderFns } from "./BookingVoyages.vue?vue&type=template&id=18a6f3e9&scoped=true&"
import script from "./BookingVoyages.vue?vue&type=script&lang=js&"
export * from "./BookingVoyages.vue?vue&type=script&lang=js&"
import style0 from "./BookingVoyages.vue?vue&type=style&index=0&id=18a6f3e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a6f3e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a6f3e9')) {
      api.createRecord('18a6f3e9', component.options)
    } else {
      api.reload('18a6f3e9', component.options)
    }
    module.hot.accept("./BookingVoyages.vue?vue&type=template&id=18a6f3e9&scoped=true&", function () {
      api.rerender('18a6f3e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/booking/BookingVoyages.vue"
export default component.exports